import React from 'react';
import clsx from 'clsx';
import DOMPurify from 'dompurify';

type Props = {
  content: string;
  className?: string;
};

export default function SanitizedHtml({ content, className }: Props) {
  return (
    <div
      className={clsx('ck-content', className)}
      // oxlint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
    />
  );
}
